import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	documentTitleCmdbAssets: {
		id: 'spa-apps-servicedesk-cmdb-object-v2.document-title-cmdb-assets',
		defaultMessage: '[{objectKey}] {objectName} - Assets',
		description: 'Document title for the CMDB object page',
	},
});
